import axios from "axios";

// Detect if app is running locally or on live site
const isLocal = window.location.hostname === "localhost";

// Automatically switch API base
const API = axios.create({
  baseURL: isLocal
    ? "http://localhost/jyotish_karmaa_api" // your local PHP folder
    : "https://visnology.com/jyotish_karmaa_api", // live Hostinger path
});

// Attach token if present
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default API;
